<div class="center-small-container">

  <h1 class="page-title-center">Delete account</h1>

  <div class="red-container text-center" style="margin-bottom: 0px;">
    Attention! This action is irreversible!
  </div>

  <br />
  <form
    class="account-update-form gap-15"
    [formGroup]="deleteForm"
    (ngSubmit)="deleteAccount()"
    >
    <mat-form-field appearance="outline">
      <mat-label>Password</mat-label>
      <input
        matInput
        [type]="hide() ? 'password' : 'text'"
        formControlName="password"
        placeholder="Enter your password"
        />
      <button
        class="mr-7"
        mat-button
        matSuffix
        (click)="hide.set(!hide())"
        type="button"
        >
        {{ hide() ? "Show" : "Hide" }}
      </button>
      @if (deleteForm.get('password')?.invalid) {
        <mat-error
          >Password is required</mat-error
          >
        }
      </mat-form-field>

      <button
        mat-flat-button
        class="mat-button-squared-full-width"
        type="submit"
        matTooltip="Delete"
        [disabled]="deleteForm.invalid"
        >
        Delete
      </button>


      <div class="yellow-container text-center" style="margin-bottom: 0px;">
        You will have a chance to confirm this action one more time.
      </div>

    </form>

    <br />

    <div class="bottom-actions">
      <button
        mat-button
        (click)="goBack()"
        matTooltip="Go back"
        >
        Go back
      </button>
    </div>

  </div>
